import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  root: {
    borderRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, { boxShadow: 'none' })
  },
  primary: {
    composes: '$root',
    backgroundColor: theme.colors.card_background_primary,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  primaryEditable: {
    composes: '$root',
    backgroundColor: theme.colors.card_background_primary_editable,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  secondary: {
    composes: '$root',
    backgroundColor: theme.colors.card_background_secondary,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  tertiary: {
    composes: '$root',
    backgroundColor: theme.colors.card_background_tertiary,
    ...reskinStyles(theme, { border: 0 })
  },
  quatrinary: {
    composes: '$root',
    backgroundColor: theme.colors.info__label_secondary,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  modal: {
    composes: '$root',
    backgroundColor: theme.colors.card_background_modal
  },
  highlight: {
    composes: '$root',
    backgroundColor: theme.colors.card_background_highlight,
    ...reskinStyles(theme, theme.cardStyles.highlight)
  },
  outline: {
    composes: '$root',
    background: 'transparent',
    border: `2px solid ${theme.colors.card_background_primary}`,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },

  outlineBeige: {
    borderRadius: 8,
    border: `2px solid ${theme.colorPalette.beige_50}`,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  noBorders: {
    borderRadius: 0,
    backgroundColor: theme.colors.card_background_primary,
    borderTop: `1px solid ${theme.colors.card_background_primary_editable}`,
    ...reskinStyles(theme, { border: 0, borderTop: `1px solid ${theme.colors.card_divider}` })
  },
  noBordersTop: {
    composes: '$noBorders',
    borderRadius: `0 0 ${theme.sizes.roundCorners}px ${theme.sizes.roundCorners}px`,
    ...reskinStyles(theme, { border: 0 })
  },
  scrollable: {
    maxHeight: 630,
    overflowY: 'scroll'
  },
  noData: {
    height: 232,
    display: 'flex'
  },
  refund: {
    composes: '$root',
    backgroundColor: theme.colorPalette.beige_50
  },
  error: {
    border: `1px solid ${theme.colors.error}`
  },
  light: {
    backgroundColor: theme.colorPalette.beige_50,
    color: theme.colorPalette.green_90,
    border: `2px solid ${theme.colorPalette.beige_50}`
  }
});

export default makeStyles(styles);
